(function () {
  if (window.TownWineHeroSlider) {
    if (typeof window.TownWineHeroSlider.init === 'function') {
      window.TownWineHeroSlider.init(document);
    }
    return;
  }

  function getSliders(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('[data-hero-slider]'));
  }

  function clearSliderTimer(slider) {
    if (slider && slider.__townwineHeroTimer) {
      window.clearInterval(slider.__townwineHeroTimer);
      slider.__townwineHeroTimer = null;
    }
  }

  function bindSlider(slider) {
    if (!(slider instanceof HTMLElement)) {
      return;
    }

    clearSliderTimer(slider);

    var track = slider.querySelector('[data-hero-slider-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];

    if (!(track instanceof HTMLElement) || slides.length <= 1) {
      if (track instanceof HTMLElement) {
        track.style.transform = 'translateX(0%)';
      }
      return;
    }

    var prefersReducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var autoplayMs = Number(slider.dataset.autoplayMs || 5000);
    if (!Number.isFinite(autoplayMs) || autoplayMs < 2000) {
      autoplayMs = 5000;
    }

    var currentIndex = 0;

    function render() {
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
    }

    render();

    if (prefersReducedMotion) {
      return;
    }

    slider.__townwineHeroTimer = window.setInterval(function () {
      currentIndex = (currentIndex + 1) % slides.length;
      render();
    }, autoplayMs);
  }

  function init(root) {
    getSliders(root).forEach(bindSlider);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    getSliders(event.target).forEach(clearSliderTimer);
  });

  window.TownWineHeroSlider = {
    init: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }
})();
